interface UserAvatarProps {
  name: string
  photoUrl?: string | null
  className?: string
}

/**
 * Identity chip for the app bar. Decorative by default — the header renders the
 * name beside it, so the avatar itself is hidden from screen readers rather than
 * repeating it.
 */
export function UserAvatar({ name, photoUrl, className = '' }: UserAvatarProps) {
  const base =
    'flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full select-none'

  if (photoUrl) {
    return <img src={photoUrl} alt="" aria-hidden className={`${base} object-cover ${className}`} />
  }

  return (
    <span
      aria-hidden
      className={`${base} bg-brand-100 text-brand-700 text-[11px] font-semibold tracking-wide ${className}`}
    >
      {initials(name)}
    </span>
  )
}

/** First letter of the first two words — "Le Plov" reads as "LP". */
function initials(name: string): string {
  const letters = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')

  return letters.toUpperCase() || 'N'
}
